import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import {  ListGroup, Form } from 'react-bootstrap';
import axios from "axios";
import Nuova_ditta from "./Ditta_x10_modal_nuova_ditta.jsx";
import Cerca_una_ditta from "./Ditta_x11_Cerca_ditta.jsx";

const { Tipologia_Aziende, Tipologia_Aziende_lungo, Tipologia_Aziende_colore } = require('../Funzioni_comuni_tipologia_aziende')
const lista = Tipologia_Aziende()
const lista_colori = Tipologia_Aziende_colore()


const Menu_generale_ditte = (props) => {
//    const [somma, calcola_somma] = useState('');
    const lista = Tipologia_Aziende()
    const lista_lunga = Tipologia_Aziende_lungo()


    function handleChange(event) {
//        event.preventDefault()
//        event.persist();
        console.log(event.target)
        const { name, value, type } = event.target;
        console.log('cc5' + name + event.target.checked)
    
        {
            props.SET_input_tipologia(prevInput => {
                return {
                    ...prevInput,
                    [name]: event.target.checked
                }
            })
        } 
        if (event.target.checked) {
            axios.put('/tutor/aggiungi_tipologia_azienda/' + props.tutor._id + '/' + name) 
            .then((res) => {
    //      console.log('Aggiunta una classe')
    //            console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        }
        if (!event.target.checked) {
            axios.put('/tutor/togli_tipologia_azienda/' + props.tutor._id + '/' + name) 
            .then((res) => {
    //      console.log('Aggiunta una classe')
    //            console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        }

        console.log(props.input_tipologia);
        
    }

    function colorazione(tipo_corto) {

//        console.log(tipo_corto)
//        console.log(lista_colori)

        let index = lista.indexOf(tipo_corto)
     

        var hStyle = { backgroundColor: lista_colori[index], margin: '5px', padding: '5px' };
        return hStyle;
    }


    return (
    <>
        <Cerca_una_ditta boolean_lista_ditte = {props.boolean_lista_ditte} 
                         SET_ricerca_ditta={props.SET_ricerca_ditta} 
                         SET_lista_ditte = {props.SET_lista_ditte}
                         ricerca_ditta={props.ricerca_ditta} 
                         variab_aggiorna= {props.variab_aggiorna}
                         /> 
        <Nuova_ditta tutor={props.tutor} SET_variab_aggiorna={props.SET_variab_aggiorna} />
        <ListGroup>
        {/* idroslab  per disabilitare completamente un menu */}
    
        <fieldset disabled={props.ricerca_ditta} >
    
            {lista.map(function (item1, index2) {
                {
                    //                        console.log(item)
                    return <div  style={colorazione(item1)}>
                        
                        <Form.Check // prettier-ignore
                        type='checkbox'
                        name={item1} 
                        onChange={handleChange}  
                        checked = {props.input_tipologia[item1]}                  
//                        disabled = {props.ricerca}
                        label={lista_lunga[index2]}
                        />
                    </div>
                }
            })
            }
        </fieldset>
        </ListGroup>
    
    </>
    )
}
export default Menu_generale_ditte;